import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { getMeasureSDocs } from "../../../../../server/server";

interface StratDocsMeasureModalProps {
  open: boolean;
  onClose: () => void;
  item: any;
}

const StratDocsMeasureModal: React.FC<StratDocsMeasureModalProps> = ({
  open,
  onClose,
  item,
}) => {
  const [toggleState, setToggleState] = useState<boolean | null>(null);
  const [docNames, setDocNames] = useState<string[]>([]);

  const fetchData = async () => {
    if (!item?.id) return;

    const resp = await getMeasureSDocs(item.measureId);

    if (resp?.status === 200) {
      setToggleState(resp?.data?.show ?? null);
      setDocNames(
        resp?.data?.names && resp.data.names.length > 0
          ? resp.data.names
          : [""],
      );
    } else {
      setDocNames([""]);
    }
  };

  useEffect(() => {
    if (open && item?.id) {
      fetchData();
    } else if (!open) {
      setToggleState(null);
      setDocNames([]);
    }
  }, [open, item?.id]);

  const handleClose = () => {
    setToggleState(null);
    setDocNames([]);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      disableEnforceFocus
      disableAutoFocus
    >
      <DialogTitle>
        <div className="flex justify-between items-center">
          <span className="text-[#04438b] text-2xl font-bold">
            Стратешки документи - {item?.measureName}
          </span>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="pt-4 w-full flex flex-col">
          {toggleState === true && (
            <div>
              {docNames?.map((name, index) => (
                <div key={index} className="flex items-center my-2 w-full pt-2">
                  <TextField
                    label="Назив стратешког документа"
                    variant="outlined"
                    value={name}
                    multiline
                    minRows={1}
                    sx={{
                      width: "100%",
                      paddingRight: 2,
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "black",
                        opacity: 1,
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "black",
                      },
                    }}
                    disabled
                    inputProps={{
                      style: {
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      },
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex gap-4 p-4">
          <div
            className="border border-[#81848f] hover:bg-[#81848f] hover:text-white cursor-pointer flex items-center justify-center text-base font-semibold rounded-lg w-[150px] h-[55px]"
            onClick={handleClose}
          >
            Затвори
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default StratDocsMeasureModal;
